import MAKEUP_CATEGORIES from './makeup_categories';

const MAKEUP_PRODUCT_TYPES = {};
MAKEUP_PRODUCT_TYPES[MAKEUP_CATEGORIES.EYES] = [
  'Mascara',
  'Lash Serum',
  'Shadow',
  'Highlighter',
  'Under-eye Concealer',
  'Pencil/Liner',
  'Brow',
  'Primer',
];
MAKEUP_PRODUCT_TYPES[MAKEUP_CATEGORIES.LIPS] = [
  'Stick',
  'Gloss',
  'Cream',
  'Liquid',
  'Stain',
  'Pencil/Liner',
];
MAKEUP_PRODUCT_TYPES[MAKEUP_CATEGORIES.FACE] = [
  'Foundation',
  'Tinted Moisturizer',
  'CC/BB Cream',
  'Primer',
  'Concealer',
  'Blush/Bronzer',
  'Powder',
  'Highlight/Contour',
];
MAKEUP_PRODUCT_TYPES[MAKEUP_CATEGORIES.NAILS] = [
  'Polish',
  'Top Coat',
  'Base Coat',
  'Nail Care',
  'Nail Art',
  'Nail Polish Remover',
];
MAKEUP_PRODUCT_TYPES[MAKEUP_CATEGORIES.ACCESSORY] = [
  'Brush',
  'Applicator',
  'Sponge',
  'Brow Accessory',
  'Lash Curler',
  'Makeup Remover',
  'Blotting Paper',
];

export default MAKEUP_PRODUCT_TYPES;
